(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["jobjam-homebrew-app"] = factory();
	else
		root["jobjam-homebrew-app"] = factory();
})(window, function() {
return 